module.exports = __webpack_public_path__ + "img/case10.cc11108b.png";